<template>
  <a-layout class="ehf-layout-wrap">
    <a-layout-content class="ehf-books-content">
      <div class="content">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
  export default {
    name: 'EhfBooksContent',
  }
</script>

<style lang="scss" scoped>
  .ehf-books-content {
    min-height: 100vh !important;
    padding: 0;
    margin: 0;
  }
</style>
